<template>
  <el-dialog title="修改计算机参数" :visible.sync="visible" width="500px" :before-close="closeDialog">
    <el-form v-if="computer" ref="form" :model="computer" :rules="rules" style="width:400px" label-width="100px">
      <el-form-item label="编号" prop="no">
        <el-input v-model="computer.no" disabled></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="computer.name"></el-input>
      </el-form-item>
      <el-form-item label="IP地址" prop="ip">
        <el-input v-model="computer.ip"></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="departmentNo">
        <el-select v-model="computer.departmentNo" placeholder="请选择部门">
          <el-option v-for="item in list" :key="item.no" :label="item.name" :value="item.no"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="computer.remark"></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button @click="submit" type="primary">提 交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { rules } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    computer: {
      type: Object,
      default(){
        return {
          no: "",
          name: "",
          ip: "",
          departmentNo: "",
          remark: ""
        }
      }
    } 
  },
  data() {
    return {
      rules: {
        no:   [rules.required()],
        name: [rules.required()],
        ip:   [rules.required()],
        departmentNo: [rules.required()]
      }
    };
  },
  computed: {
    ...mapState("department", ["list"])
  },
  methods: {
    ...mapActions("computer", ["update"]),
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let res = await this.update(this.computer);
      this.$message.success("修改计算机成功");
      this.closeDialog();
    },
    closeDialog(){
      this.$emit('update:visible', false)
    }
  }
};
</script>

<style>
</style>

